module.exports = __webpack_public_path__ + "static/tomasz-d32c89ed617f9723a49f92b4c0f91b3c.png";